export default __webpack_public_path__ + "static/media/30.b6f44718.webp";